import urlParse from "url-parse";

function linkCleaner(link: string) {
  if (!link || link === "") return link;

  const linkWithProtocol = link.startsWith("http") ? link : `https://${link}`;
  // Don't parse query string into object -- retain as string.
  const parseQuery: boolean = false;
  const { protocol, host, pathname, query } = urlParse(
    linkWithProtocol,
    parseQuery,
  );

  let urlParts: string[] = [];
  urlParts.push(protocol, "//", host);
  if (pathname != "/") {
    urlParts.push(pathname);
  }
  if (query != "") {
    urlParts.push(query);
  }
  return urlParts.join("");
}

export default linkCleaner;
